import styled from "styled-components";

interface PostMediaCountsProps {
  post: {
    slideCnt?: number | null;
    imageCnt?: number | null;
    grossCnt?: number | null;
  };
}

const BADGE_COLORS = {
  Slide: { color: "#5f7795", background: "#f5f7fb", border: "#dde4ee" },
  Image: { color: "#5f8574", background: "#f5f9f7", border: "#dce8e2" },
  Gross: { color: "#8c7a5c", background: "#faf8f4", border: "#ece4d6" },
} as const;

type BadgeLabel = keyof typeof BADGE_COLORS;

const PostMediaCounts = ({ post }: PostMediaCountsProps) => {
  const counts: { label: BadgeLabel; value: number }[] = [
    { label: "Slide" as const, value: post.slideCnt ?? 0 },
    { label: "Image" as const, value: post.imageCnt ?? 0 },
    { label: "Gross" as const, value: post.grossCnt ?? 0 },
  ].filter(({ value }) => value > 0);

  if (counts.length === 0) return null;

  return (
    <CountsWrapper>
      {counts.map(({ label, value }) => (
        <Badge key={label} $label={label}>
          {label}
          <BadgeValue>{value}</BadgeValue>
        </Badge>
      ))}
    </CountsWrapper>
  );
};

export default PostMediaCounts;

const CountsWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  padding-left: 16px;
  flex-shrink: 0;
  white-space: nowrap;
`;

const Badge = styled.span<{ $label: BadgeLabel }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border-radius: 999px;
  border: 1px solid ${({ $label }) => BADGE_COLORS[$label].border};
  background: ${({ $label }) => BADGE_COLORS[$label].background};
  color: ${({ $label }) => BADGE_COLORS[$label].color};
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
`;

const BadgeValue = styled.span`
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;
